import React from 'react';
import ReactDom from 'react-dom';
import  App  from './App';
//import Screen2 from './screens/Screen2'

ReactDom.render(<App/>,document.getElementById('root'));
